/* eslint-disable no-unused-vars */
import preact from 'preact'
/* eslint-enable no-unused-vars */
import { t } from 'libs/translationsUtils/translations'

const TopicTooltip = ({ topic }) => {
  let iconClass = topic.type === 'ideation' ? 'icon--idea' : ''
  let iconStyle = topic.type === 'ideation' && topic.ideationStatus ? { color: topic.ideationStatus.bgColor } : ''
  let label = topic.type === 'ideation' && topic.ideationStatus ? topic.ideationStatus.name : ''

  if (!(topic.features && topic.features[0]) && !(topic.type === 'ideation')) {
    /* if topic is post and not of type ideation or question */
    return null
  }

  if (topic.type === 'post') {
    iconClass = topic.features[0].id === 'isQuestion' ? 'icon--question-circle' : topic.features[0].id === 'isAnswered' ? 'icon--thread-solved' : ''
    label = t('Forum', topic.features[0].label)
  }

  return (<div class='tooltip tooltip--day tooltip--thread-type' title={label}>
    <div class='js-tooltip-trigger' aria-haspopup='true'>
      <i class={'icon--auto-width ' + iconClass} style={iconStyle} />
    </div>
  </div>)
}

export default TopicTooltip
